import ReservationSegmentCardDispatcher from "../dispatcher/ReservationSegmentCardDispatcher";
import ReservationSegmentCardConstants from "../constants/ReservationSegmentCardConstants";
import DateHelper from "../../DateHelper/DateHelper";
import { parseISO } from "date-fns";

var objectAssign = require("object-assign");
var EventEmitter = require("events").EventEmitter.prototype;
var ReservationSegmentCardStore = objectAssign({}, EventEmitter, {
  _state: {
    active_tab: "details",
    read_only: false,
    initialized: false,
    note_count: 0,
    service_request_count: 0,
    system_notification_count: 0,
    form_count: 0,
    pin_code: null,

    errors: [],

    new_payment_log_path: null,
    reservation_segment_pricing_path: null,
    reservation_segment_email_path: null,
    reservation_segment_payment_path: null,
    reservation_segment_housekeeping_path: null,
    reservation_segment_history_path: null,
    reservation_segment_folios_path: null,
    reservation_segment_save_path: null,
    reservation_segment_service_logs_path: null,
    reservation_details_data_table_path: null,
    folio_summary_data_path: null,
    reservation_segment_forms_path: null,

    reservation_segment: null,
    reservation_segment_device_accesses: [],
    incidental_deposit: null,
    originalReservationSegment: null,
    originalReservation: null,
    buttons: null,

    maximum_stay: null,
    minimum_stay: null,
    maximum_stay_override: null,
    minimum_stay_override: null,

    seasons: null,

    summary: null,

    date_format: null,

    showEditCustomers: true,
    showEditIncidentalDeposit: true,
    showEditRoom: true, //this.props.reservation_segment.room ? false : true,
    showEditRoomType: true,

    loading: false,
    numberFormat:
      "0" +
      ($("#delimiter").val() || ",") +
      "0" +
      ($("#separator").val() || ".") +
      "00",
    messages: [],
    active_tab: "details",
  },

  emitChange: function () {
    this.emit(ReservationSegmentCardConstants.CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.on(ReservationSegmentCardConstants.CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener: function (callback) {
    this.removeListener(ReservationSegmentCardConstants.CHANGE_EVENT, callback);
  },

  init: function (opts) {
    var self = this;

    objectAssign(this._state, opts);

    this._state.loading = true;
    this.loadData(opts).then(() => {
      self._state.reservation_segment.balance_amount = 0;
      self._state.current_minimum_stay = this.calculateMinimumStay(
        self._state.reservation_segment.check_in_date,
        self._state.reservation_segment.check_out_date
      );
      self._state.current_maximum_stay = this.calculateMaximumStay(
        self._state.reservation_segment.check_in_date,
        self._state.reservation_segment.check_out_date
      );
      this._state.read_only = opts.read_only;
      this.findExistingSegments();
      // this.assignCustomer();
      this.parseDates();
      this.setOriginalSegment();
      this.setOriginalReservation();
      this.setPaymentLog();
      this._state.showEditRoomType = true;

      self._state.initialized = true;
      this._state.loading = false;
      this.emitChange();
    });
  },

  // setReadOnly: function() {
  //   if(this._state.reservation_segment.status === "checked_out" || this._state.reservation_segment.status === "canceled") {
  //     this._state.read_only = true;

  //   }
  // },

  findExistingSegments: function () {
    var self = this;
    let res = Object.assign({}, self._state.reservation);
    if (res.reservation_segments && res.reservation_segments.length) {
      self._state.existing_reservation_segments =
        res.reservation_segments.slice();
      self._state.existing_reservation_segment_ids =
        self._state.existing_reservation_segments.map(function (s) {
          return s.id;
        });
    }
  },

  assignCustomer: function () {
    var self = this;
    let res = Object.assign({}, self._state.reservation);
    let seg = Object.assign({}, self._state.reservation_segment);

    if (
      self._state.reservation_segment.customers &&
      self._state.reservation_segment.customers.length === 0
    ) {
      self._state.reservation_segment.customers.push(res.customer);
      self._state.reservation_segment.incidental_deposit_card =
        seg.customers[0].cards[0];
    }
  },

  parseDates: function () {
    var self = this;

    if (self._state.reservation_segment.check_in_date) {
      self._state.reservation_segment.check_in_date = new Date(
        self._state.reservation_segment.check_in_date
      );
    }

    if (self._state.reservation_segment.check_out_date) {
      self._state.reservation_segment.check_out_date = new Date(
        self._state.reservation_segment.check_out_date
      );
    }

    if (self._state.reservation_segment.room_available_until) {
      self._state.reservation_segment.room_available_until = new Date(
        self._state.reservation_segment.room_available_until
      );
    }

    if (self._state.reservation.start_date) {
      self._state.reservation.start_date = new Date(
        self._state.reservation.start_date
      );
    }

    if (self._state.reservation.end_date) {
      self._state.reservation.end_date = new Date(
        self._state.reservation.end_date
      );
    }
  },

  loadData: function (opts) {
    var self = this;
    var endpoint = opts.endpoint;
    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: endpoint,
        data: {},
      }).done(function (data) {
        if (data) {
          self._state.reservation_segment = data.reservation_segment;
          self._state.reservation_segment.check_in_date = parseISO(
            data.reservation_segment.check_in_date
          );
          self._state.reservation_segment.check_out_date = parseISO(
            data.reservation_segment.check_out_date
          );

          self._state.reservation_segment.reservation_id = data.reservation.id;
          // self._state.reservation = data.reservation_segment.reservation
          self._state.reservation = data.reservation;

          self._state.incidental_deposit = data.incidental_deposit;

          self._state.reservation_segment_device_accesses =
            data.reservation_segment.reservation_segment_device_accesses;

          // Folio State setting
          self._state.folio_id = data.folio_id;
          self._state.total = data.total;
          self._state.balance = data.balance;
          self._state.total_paid = data.total_paid;
          self._state.discounts = data.discounts;
          self._state.subtotal = data.subtotal;
          self._state.taxes = data.taxes;

          if (self._state.reservation.customer) {
            self._state.reservation.customer.actions =
              data.reservation_segment.customer_actions;
          }
          resolve();
        } else {
          reject();
        }
      });
    });
    return promise;
  },

  refresh: function (opts) {
    var self = this;
    this._state.loading = true;

    this.loadData(opts).then(() => {
      self._state.reservation_segment.balance_amount = 0;
      self._state.current_minimum_stay = this.calculateMinimumStay(
        self._state.reservation_segment.check_in_date,
        self._state.reservation_segment.check_out_date
      );
      self._state.current_maximum_stay = this.calculateMaximumStay(
        self._state.reservation_segment.check_in_date,
        self._state.reservation_segment.check_out_date
      );
      this._state.read_only = opts.read_only;
      this.findExistingSegments();
      // this.assignCustomer();
      this.parseDates();
      this.setOriginalSegment();
      this.setOriginalReservation();
      this.setPaymentLog();

      this._state.showEditRoomType = true;

      self._state.initialized = true;
      this._state.loading = false;
      this.emitChange();
    });
  },

  addUpdatedSegmentInfo: function () {
    var self = this;
    let updatedReservation = Object.assign({}, self._state.reservation);
    updatedReservation.reservation_segments.unshift(
      Object.assign({}, self._state.reservation_segment)
    );
    self._state.reservation = updatedReservation;
  },

  removeUpdatingSegment: function () {
    var self = this;
    let reservation = Object.assign({}, self._state.reservation);

    for (i = 0; i < reservation.reservation_segments.length; i++) {
      if (
        reservation.reservation_segments[i].id ===
        self._state.reservation_segment.id
      ) {
        reservation.reservation_segments.splice(i, 1);
      }
    }
    self._state.reservation = reservation;
  },

  changeDates: function (payload) {
    var self = this;
    self._state.loading = true;

    let reservation_segment = Object.assign(
      {},
      self._state.reservation_segment
    );
    reservation_segment.check_in_date = payload.check_in_date;
    reservation_segment.check_out_date = payload.check_out_date;
    self._state.reservation_segment = reservation_segment;

    self.removeUpdatingSegment();
    self.addUpdatedSegmentInfo();

    self.calculatePricing().then(() => {
      self._state.reservation.reservation_segments[0] = Object.assign(
        {},
        self._state.reservation_segment
      );
      self._state.reservation.confirmation_number =
        self._state.originalReservation.confirmation_number;
      self.calculateBalance();
      self.parseDates();
      self._state.loading = false;
      self.emitChange();
    });
  },

  changeRate: function (payload) {
    var self = this;
    this._state.loading = true;
    this._state.reservation_segment.rate_id = payload.rate_id;

    this.removeUpdatingSegment();
    this.addUpdatedSegmentInfo();

    this.calculatePricing().then(() => {
      self._state.reservation.reservation_segments[0] = Object.assign(
        {},
        self._state.reservation_segment
      );
      self._state.reservation.confirmation_number =
        self._state.originalReservation.confirmation_number;
      this.calculateBalance();
      this.parseDates();
      self._state.loading = false;
      this.emitChange();
    });
  },

  changeRoomType: function (payload) {
    var self = this;
    this._state.loading = true;

    this._state.reservation_segment.room_type = {
      id: payload.room_type.id,
      name: payload.room_type.name,
    };

    if (
      this._state.reservation_segment.room_type.id !=
      this._state.originalReservationSegment.room_type.id
    ) {
      this._state.reservation_segment.room = null;
    } else {
      this._state.reservation_segment.room =
        this._state.originalReservationSegment.room;
    }

    this.removeUpdatingSegment();
    this.addUpdatedSegmentInfo();

    this.calculatePricing().then(() => {
      self._state.reservation.reservation_segments[0] = Object.assign(
        {},
        self._state.reservation_segment
      );
      self._state.reservation_segment.rate = null;
      self._state.reservation_segment.rate_id = null;
      self._state.reservation.confirmation_number =
        self._state.originalReservation.confirmation_number;
      this.calculateBalance();
      this.parseDates();
      self._state.loading = false;
      this.emitChange();
    });
  },

  applyDiscount: function (reservation, reservation_segment) {
    var self = this;

    if (
      reservation_segment.errors &&
      reservation_segment.errors.base &&
      reservation_segment.errors.base.length
    ) {
      self._state.errors = [];
      reservation_segment.errors.base.map(function (error) {
        self._state.errors.push(error);
      });
      self.emitChange();
    }

    objectAssign(self._state.reservation_segment, reservation_segment);
    objectAssign(self._state.reservation, reservation);

    self._state.reservation.reservation_segments[0] = Object.assign(
      {},
      self._state.reservation_segment
    );
    self._state.reservation.confirmation_number =
      self._state.originalReservation.confirmation_number;
    this.calculateBalance();
    this.parseDates();

    this.emitChange();
  },

  applyPromotion: function (reservation, reservation_segment) {
    var self = this;
    if (
      reservation_segment.promotion &&
      reservation_segment.promotion.errors &&
      reservation_segment.promotion.errors.base &&
      reservation_segment.promotion.errors.base.length
    ) {
      reservation_segment.promotion.errors.base.map(function (error) {
        self._state.errors.push(error);
      });
      self.emitChange();
    } else {
      objectAssign(self._state.reservation_segment, reservation_segment);
      objectAssign(self._state.reservation, reservation);

      self._state.reservation.reservation_segments[0] = Object.assign(
        {},
        self._state.reservation_segment
      );
      self._state.reservation.confirmation_number =
        self._state.originalReservation.confirmation_number;
      this.calculateBalance();
      this.parseDates();

      this.emitChange();
    }
  },

  calculatePricing: function () {
    var self = this;

    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: "/admin/reservations/calculate-pricing",
        data: {
          existing_reservation_segment_ids:
            self._state.existing_reservation_segment_ids,
          reservation: self._state.reservation,
        },
      }).done(function (data) {
        if (data && data.errors && data.errors.length == 0) {
          objectAssign(
            self._state.reservation_segment,
            data.reservation_segments[0]
          );
          objectAssign(self._state.reservation, data);

          resolve();
        } else {
          reject();
        }
      });
    });
    return promise;
  },

  makeId: function () {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 12; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  },

  checkIn() {
    this._state.loading = true;
    this.savePaymentLog().then(() => {
      this.save();
    });
  },

  reactivateLocks(room_locks) {
    this._state.reservation_segment.room_locks = room_locks;
  },

  // activateLocks(
  //   reservation_segment_device_accesses,
  //   remotelock_start_datetime_override,
  //   remotelock_end_datetime_override
  // ) {
  //   this._state.reservation_segment_device_accesses =
  //     reservation_segment_device_accesses;
  //   if (
  //     remotelock_start_datetime_override &&
  //     remotelock_end_datetime_override
  //   ) {
  //     this._state.reservation_segment.remotelock_start_datetime_override =
  //       remotelock_start_datetime_override;
  //     this._state.reservation_segment.remotelock_end_datetime_override =
  //       remotelock_end_datetime_override;
  //   }
  // },

  // dectivateLocks(reservation_segment_device_accesses) {
  //   this._state.reservation_segment_device_accesses =
  //     reservation_segment_device_accesses;
  // },

  // resetLocks() {
  //   this._state.reservation_segment_device_accesses = [];
  // },

  savePaymentLog: function () {
    var self = this;
    return new Promise((resolve, reject) => {
      $.ajax({
        type: "POST",
        url: "/admin/payment-logs/save",
        data: {
          payment_log: {
            customer_id: self._state.payment_log.customer_id,
            card_id: self._state.payment_log.card_id,
            reservation_id: self._state.payment_log.reservation_id,
            reservation_segment_id:
              self._state.payment_log.reservation_segment_id,
            amount: self._state.payment_log.amount,
            log_type: "Incidentals",
          },
          payment_type: self._state.payment_log.payment_type,
        },
      }).done((data) => {
        data.success ? resolve() : reject();
      });
    });
  },

  save: function () {
    var self = this;

    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "PATCH",
        url: self._state.reservation_segment_save_path,
        data: {
          reservation_segment: {
            room_type_id: self._state.reservation_segment.room_type
              ? self._state.reservation_segment.room_type.id
              : null,
            room_id: self._state.reservation_segment.room
              ? self._state.reservation_segment.room.id
              : null,
            check_in_date: self._state.reservation_segment.check_in_date,
            check_out_date: self._state.reservation_segment.check_out_date,
            notes: self._state.reservation_segment.notes,
            customer_ids: self._state.reservation_segment.customers.map(
              function (customer) {
            // promotion_id: self._state.reservation_segment.promotion ? self._state.reservation_segment.promotion.id : null,
              }
            ),
            incidental_deposit_card_id: self._state.reservation_segment
              .incidental_deposit_card
              ? self._state.reservation_segment.incidental_deposit_card.id
              : null,
            promotion_id: self._state.reservation_segment.promotion
              ? self._state.reservation_segment.promotion.id
              : null,
            number_of_guests: self._state.reservation_segment.number_of_guests,
            discount_amount: self._state.reservation_segment.discount_amount,
            discount_percentage:
              self._state.reservation_segment.discount_percentage,
            discount_number_of_nights:
              self._state.reservation_segment.discount_number_of_nights,
            rate_id: self._state.reservation_segment.rate_id,
          },
          status: self._state.reservation_segment.status,
        },
      }).done(function (data) {
        if (data.errors && data.errors.length) {
          self._state.errors = [];
          for (i = 0; i < data.errors.length; i++) {
            self._state.errors.push(data.errors[i]);
          }
          self.emitChange();
        } else {
          if (parent && parent.refresh_data) {
            parent.refresh_data(I18n.t("updated_successfully"));
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        }
      });
    });
  },

  getCustomers: function (customers) {
    var self = this;
    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "GET",
        url: "/admin/get-customers",
        data: {
          customer_ids: customers.map(function (customer) {
            return customer.id;
          }),
        },
      }).done(function (data) {
        if (data) {
          self._state.reservation_segment.customers = data;
          resolve();
        } else {
          reject();
        }
      });
    });
    return promise;
  },

  changeCustomers: function (customers) {
    this._state.loading = true;
    this.getCustomers(customers).then(() => {
      this._state.loading = false;
      this.emitChange();
    });
  },

  changeStatus: function (status) {
    this._state.reservation_segment.status = status;
  },

  changeFolio: function (folio_id) {
    this._state.loading = true;
    this.getFolioData(folio_id).then(() => {
      this._state.loading = false;
      this.emitChange();
    });
  },

  getFolioData() {
    var self = this;
    this.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: self.props.folio_summary_data_path,
      data: {},
    })
      .done((data) => {})
      .catch((data) => {
        if (data && data.responseJSON) {
          this.setState({ errors: data.responseJSON, loading: false });
          $("modal-body").scrollTop(0);
        }
      });
  },

  getPaymentLog: function () {
    var self = this;
    var endpoint = this._state.find_payment_log_path;
    var promise = new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: endpoint,
        data: {
          payment_log: {
            reservation_segment_id: self._state.reservation_segment.id,
            reservation_id: self._state.reservation_segment.reservation.id,
            amount: self._state.reservation_segment.balance_amount,
          },
        },
      }).done(function (data) {
        if (data) {
          self._state.refund_payment_log = data.payment_log;
          resolve();
        } else {
          reject();
        }
      });
    });
    return promise;
  },

  calculateBalance: function () {
    this._state.reservation_segment.balance_amount =
      this._state.reservation_segment.total_amount -
      this._state.originalReservationSegment.total_amount;
  },

  calculateMinimumStay: function (check_in_date, check_out_date) {
    if (this._state.minimum_stay_override != null) {
      return this._state.minimum_stay_override;
    }

    if (this._state.seasons && this._state.season.length > 0) {
      for (var i = 0, ilen = this._state.seasons.length; i < ilen; i++) {
        var season = this._state.seasons[i];

        if (season.minimum_stay == null) {
          continue;
        }

        season.start_date = DateHelper.parseDateFromBackend(season.start_date);
        season.end_date = DateHelper.parseDateFromBackend(season.end_date);

        if (
          DateHelper.between(
            check_in_date,
            check_out_date,
            season.start_date,
            season.end_date
          )
        ) {
          return season.minimum_stay;
        }
      }
    }

    if (this._state.minimum_stay !== null) {
      return this._state.minimum_stay;
    } else {
      return 1;
    }
  },

  calculateMaximumStay: function (check_in_date, check_out_date) {
    if (this._state.maximum_stay_override != null) {
      return this._state.maximum_stay_override;
    }

    if (this._state.seasons && this._state.seasons.length > 0) {
      for (var i = 0, ilen = this._state.seasons.length; i < ilen; i++) {
        var season = this._state.seasons[i];

        if (season.maximum_stay == null) {
          continue;
        }

        season.start_date = DateHelper.parseDateFromBackend(season.start_date);
        season.end_date = DateHelper.parseDateFromBackend(season.end_date);

        if (
          DateHelper.between(
            check_in_date,
            check_out_date,
            season.start_date,
            season.end_date
          )
        ) {
          return season.maximum_stay;
        }
      }
    }

    if (this._state.maximum_stay !== null) {
      return this._state.maximum_stay;
    } else {
      return 28; //default
    }
  },

  validMaximumStay: function (check_in_date, check_out_date) {
    var maximumStay = this.calculateMaximumStay(check_in_date, check_out_date);

    if (DateHelper.diffInDays(check_in_date, check_out_date) > maximumStay) {
      return maximumStay;
    } else {
      return true;
    }
  },

  validMinimumStay: function (check_in_date, check_out_date) {
    var minimumStay = this.calculateMinimumStay(check_in_date, check_out_date);

    if (DateHelper.diffInDays(check_in_date, check_out_date) < minimumStay) {
      return minimumStay;
    } else {
      return true;
    }
  },

  setPaymentLog: function () {
    var self = this;

    self._state.payment_log = {
      customer_id: self._state.reservation.customer
        ? self._state.reservation.customer.id
        : null,
      card_id: self._state.reservation.customer
        ? self._state.reservation.customer.cards &&
          self._state.reservation.customer.cards.length > 0
          ? self._state.reservation.customer.cards[0].id
          : null
        : null,
      reservation_id: self._state.reservation.id,
      reservation_segment_id: self._state.reservation_segment.id,
      amount: null,
      log_type: "Incidentals",
      payment_type: "auth_and_hold_amount",
    };
  },

  setOriginalSegment: function () {
    var self = this;
    let seg = Object.assign({}, self._state.reservation_segment);

    self._state.originalReservationSegment = {
      id: seg.id,
      total_amount: seg.total_amount,
      status: seg.status,
      customers: seg.customers,
      incidental_deposit: seg.incidental_deposit,
      incidental_deposit_card: seg.incidental_deposit_card,
      incidental_deposit_amount: seg.incidental_deposit_amount,
      folios: seg.folios,
      reservation: seg.reservation,
      room_type: seg.room_type,
      room: seg.room,
    };
  },

  setOriginalReservation: function () {
    var self = this;
    let reservation = Object.assign({}, self._state.reservation);

    self._state.originalReservation = {
      id: reservation.id,
      confirmation_number: reservation.confirmation_number,
      reservation_segments: reservation.reservation_segments,
    };
  },

  getState: function () {
    return this._state;
  },
});

ReservationSegmentCardStore.dispatchToken =
  ReservationSegmentCardDispatcher.register(function (payload) {
    switch (payload.action) {
      case ReservationSegmentCardConstants.INIT:
        ReservationSegmentCardStore.init(payload.opts);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.REFRESH:
        ReservationSegmentCardStore.refresh(payload.opts);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.SAVE:
        ReservationSegmentCardStore.save();
        break;

      case ReservationSegmentCardConstants.SET_ACTIVE_TAB:
        ReservationSegmentCardStore._state.active_tab = payload.tab;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.SET_SUBMIT_BUTTON:
        ReservationSegmentCardStore._state.submitButton = payload.submitButton;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_ROOM:
        ReservationSegmentCardStore._state.reservation_segment.room =
          payload.room;
        ReservationSegmentCardStore._state.reservation_segment.room_id =
          payload.room.id;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_CUSTOMERS:
        ReservationSegmentCardStore.changeCustomers(payload.customers);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_INCIDENTAL_DEPOSIT_CARD:
        ReservationSegmentCardStore._state.reservation_segment.incidental_deposit_card =
          payload.incidental_deposit_card;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_STATUS:
        ReservationSegmentCardStore.changeStatus(payload.status);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.EDIT_RESERVATION_SEGMENT:
        ReservationSegmentCardStore.editReservationSegment(payload);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_PAYMENT_CARD:
        ReservationSegmentCardStore._state.payment_log.card_id =
          payload.card_id;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_PAYMENT_CUSTOMER:
        ReservationSegmentCardStore._state.payment_log.customer_id =
          payload.customer_id;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_PAYMENT_AMOUNT:
        ReservationSegmentCardStore._state.payment_log.amount = payload.amount;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_PAYMENT_TYPE:
        ReservationSegmentCardStore._state.payment_log.payment_type =
          payload.payment_type;
        ReservationSegmentCardStore.emitChange();

      case ReservationSegmentCardConstants.CHANGE_PAYMENT_EVENT:
        // ReservationSegmentCardStore._state.payment_log.lifecycle_event = payload.event;
        // ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.APPLY_PROMOTION:
        ReservationSegmentCardStore.applyPromotion(
          payload.reservation,
          payload.reservation_segment
        );
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.REACTIVATE_LOCKS:
        ReservationSegmentCardStore.reactivateLocks(payload.room_locks);
        ReservationSegmentCardStore.emitChange();
        break;

      // case ReservationSegmentCardConstants.ACTIVATE_LOCKS:
      //   ReservationSegmentCardStore.activateLocks(
      //     payload.reservation_segment_device_accesses,
      //     payload.remotelock_start_datetime_override,
      //     payload.remotelock_end_datetime_override
      //   );
      //   ReservationSegmentCardStore.emitChange();
      //   break;

      // case ReservationSegmentCardConstants.DEACTIVATE_LOCKS:
      //   ReservationSegmentCardStore.dectivateLocks(
      //     payload.reservation_segment_device_accesses
      //   );
      //   ReservationSegmentCardStore.emitChange();
      //   break;

      // case ReservationSegmentCardConstants.RESET_LOCKS:
      //   ReservationSegmentCardStore.resetLocks();
      //   ReservationSegmentCardStore.emitChange();
      //   break;

      case ReservationSegmentCardConstants.CHANGE_GUESTS:
        //ReservationSegmentCardStore.changeGuests(payload);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.REMOVE_PROMOTION:
        ReservationSegmentCardStore._state.reservation_segment.promotion = null;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_NOTES:
        ReservationSegmentCardStore._state.reservation_segment.notes =
          payload.notes;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.APPLY_DISCOUNT:
        ReservationSegmentCardStore.applyDiscount(
          payload.reservation,
          payload.reservation_segment
        );
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.OVERRIDE_MIN_MAX_STAY:
        ReservationSegmentCardStore._state.minimum_stay_override =
          payload.min_stay;
        ReservationSegmentCardStore._state.maximum_stay_override =
          payload.max_stay;
        ReservationSegmentCardStore._state.current_minimum_stay =
          payload.min_stay;
        ReservationSegmentCardStore._state.current_maximum_stay =
          payload.max_stay;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_ROOM_TYPE:
        ReservationSegmentCardStore.changeRoomType(payload);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_DATES:
        ReservationSegmentCardStore.changeDates(payload);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHANGE_RATE:
        ReservationSegmentCardStore.changeRate(payload);
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.CHECK_IN:
        ReservationSegmentCardStore.checkIn();
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.UPDATE_NOTE_COUNT:
        ReservationSegmentCardStore._state.note_count = payload.count;
        ReservationSegmentCardStore.emitChange();
        break;

      case ReservationSegmentCardConstants.UPDATE_SERVICE_REQUEST_COUNT:
        ReservationSegmentCardStore._state.service_request_count =
          payload.count;
        ReservationSegmentCardStore.emitChange();
        break;

      default:
    }
  });

ReservationSegmentCardStore.setMaxListeners(0);

export default ReservationSegmentCardStore;
